<template>
  <section>
    <div class="content-wrapper">
      <div class="content-heading">
        You're an admin! HOORAY!
      </div>
    </div>
  </section>
</template>

<script>
  import HttpService from '@/api/HttpService';

  export default {
    name: 'irAdmin',
    mounted() {
      HttpService.get('authentication/ir-admin');
    },
  };
</script>



// WEBPACK FOOTER //
// IRAdmin.vue?459cba80